import { styled } from '@mui/material/styles';
import { Link, LinkProps } from 'react-router-dom';

type Props = LinkProps & {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
};

const StyledLink = styled(Link, {
  shouldForwardProp: (prop) => prop !== 'variant'
})<{ variant: 'primary' | 'secondary' }>(({ theme, variant }) => ({
  color:
    variant === 'primary'
      ? theme.palette.primary.main
      : theme.palette.customGrey.dark,
  '&:visited': {
    color: theme.palette.customGrey.dark
  }
}));

export const RouterLink = ({
  children,
  variant = 'primary',
  ...props
}: Props) => {
  return (
    <StyledLink variant={variant} {...props}>
      {children}
    </StyledLink>
  );
};
